import { Stack, Typography } from '@mui/material'
import { useMinimalsTheme } from '@tom-ui/ui'
import { FC, ReactNode } from 'react'

interface Props {
  title: ReactNode
  icon?: ReactNode
  description?: string
  displayHoverEffect?: boolean
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}
export const YardNodeHeaderTitle: FC<Props> = props => {
  const theme = useMinimalsTheme()
  const { title, icon, description, displayHoverEffect, onClick } = props

  return (
    <Stack
      sx={{
        p: theme.customSpacing.xs,
        '&:hover': {
          cursor: displayHoverEffect ? 'pointer' : 'default',
          backgroundColor: displayHoverEffect ? theme.palette.grey[200] : 'transparent',
        },
      }}
      flexDirection='row'
      alignItems='center'
      gap={1}
      flex='none'
      onClick={onClick}
    >
      {icon}
      {description && (
        <Typography variant='body1' whiteSpace='nowrap'>
          {description}
        </Typography>
      )}
      {typeof title === 'string' ? (
        <Typography variant='subtitle1' whiteSpace='nowrap'>
          {title}
        </Typography>
      ) : (
        title
      )}
    </Stack>
  )
}
